import { render, staticRenderFns } from "./addStandardComponent.vue?vue&type=template&id=1bde8f5f&scoped=true&"
import script from "./addStandardComponent.vue?vue&type=script&lang=js&"
export * from "./addStandardComponent.vue?vue&type=script&lang=js&"
import style0 from "./addStandardComponent.vue?vue&type=style&index=0&id=1bde8f5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde8f5f",
  null
  
)

export default component.exports